import { InformationSection } from '@periscopes/general';
import React from 'react';
import { SalesforceDescription } from '@ui/text';
export const ValidationRuleInformation = ({ sonarObjectId }) => React.createElement(InformationSection, { sonarObjectId: sonarObjectId },
    React.createElement(SalesforceDescription, { sonarObjectId: sonarObjectId }));
